import { TravelArticleAuthor } from './travel-article-author.model';


export class TravelArticle {
  /**
   * Unique identifier for this record in the database
   */
  Id: string;

  /**
   * Title of the article
   */
  Title: string;

  /**
   * URL of the article on Sitecore
   */
  Url: string;

  /**
   * Intro paragraph of article
   */
  Intro: string;

  /**
   * URL of thumbnail image
   */
  Image: string;

  /**
   * list of topics associated with this article
   */
  Topics: string;

  /**
   * Date article was published
   */
  Date: Date;

  /**
   * Author data
   */
  AuthorOverview: TravelArticleAuthor;

  /**
   * Parses travel article
   * @param data {any} Review data as returned by API
   * @return {Review} Parsed review
   */
  static parse(data: any): TravelArticle {
    return {
      Id: data.Id,
      Title: data.Title,
      Url: data.Url,
      Intro: data.Intro,
      Image: data.Image,
      Topics: data.Topics,
      Date: data.Date ? new Date(data.Date) : null,
      AuthorOverview: data.AuthorOverview ? TravelArticleAuthor.parse(data.AuthorOverview) : null
    };
  }
}
